<template>
	<v-card outlined>
		<v-card-title
			class = "pa-0 caption secondary text-uppercase white--text"				
		>	
			<v-icon 
				small 
				color  = "white"
				class  = "ml-1 mr-5"
				@click = "$router.back()"
			>
				mdi-arrow-left-circle
			</v-icon>
			<!-- vector-square -->
			<!-- <v-spacer></v-spacer> -->
			<v-spacer></v-spacer>			
			<v-btn
				icon
				x-small
				outlined
				width  = "17"
				height = "17"
				class  = "primary mx-2"
			>
				
				<v-icon
					x-small
					color  = "white"
					v-text = "'mdi-graphql'"
								
						
				></v-icon>
			</v-btn>
			<span 
				v-text = "$ml.get('analytic')"
			></span>
			<v-chip 
				label
				x-small 
				color = "success"
				class = "mx-2"
			> 
				{{ title }}  
			</v-chip>
			 
			<v-chip 
				label
				x-small 
			>  
				{{ title1 }} 
			</v-chip>
			
			<v-spacer></v-spacer>

			<v-btn-toggle 
				right
				absolute
				mandatory
				class  = "mt-0 mr-1 white--text"
			>
				<v-tooltip 
					bottom					
					v-model = "tooltip.update"
					color 	= "success"
				>
    				<template v-slot:activator = "{ on }"> 
						<v-btn
							small
							class  = "mr-1"
							v-on   = "on"
							color  = "primary elevation-2"					
							@click = "actions('confirm_update')"
					      	v-show = "!loading"									
						>
							<v-icon
								small
								class = "mr-1"
								color = "white"
							>
								mdi-update
							</v-icon>
							<span>
								{{ $ml.get('update') }}
							</span>
						</v-btn>
					</template>
					<span>
						{{ $ml.get('update') }}
					</span>
				</v-tooltip>
				<v-tooltip 
					bottom										
					color 	= "error"
				>
    				<template v-slot:activator="{ on }"> 
						<v-btn
							small													
							color  = "error"
							v-on   = "on"					
							@click = "actions('confirm_delete')"
					      	v-show = "!loading"												
						>
							<v-icon
								small
								color = "white"
							>
								mdi-delete
							</v-icon>
							<span>					
								{{ $ml.get('delete') }}
							</span>
						</v-btn>
					</template>
					<span>					
						{{ $ml.get('delete') }} : {{ $ml.get('container') }}
					</span>
				</v-tooltip>
			</v-btn-toggle>
			<v-progress-linear
		      	indeterminate
		      	v-show = "loading"
		      	color  = "success"
		    ></v-progress-linear>
						
		</v-card-title>
		<v-card-text class = "pt-0">

			<v-row>
					<!-- streaming -->
				<v-col 
					xl 	 = "6"
					lg 	 = "6"
					md 	 = "6"
					sm 	 = "12"
					xs 	 = "12"
					cols = "12"
				> <!--  -->
					<alarm_roi
						:info_to_component 	 	= "info_component"
						:type_shape 		 	= "'rectangle'"
						:is_to_clear  		 	= "false"
						:analytic_to_component 	= "title"
						:channel_analytic  	 	= "channel_stream"
						@action_component 	 	= "receive_component($event)" 
						:action_to_component 	= "action_roi"
					>
						
					</alarm_roi>
					
					
				</v-col>
					<!-- info -->
				<v-col 
					xl 	 = "6"
					lg 	 = "6"
					md 	 = "6"
					sm 	 = "12"
					xs 	 = "12"
					cols = "12"
				>
					<v-card outlined
						:max-height = "heigth_session_2"
					>
						<v-card-text class = "pa-1">

							<v-tabs
						      dark
						      fixed-tabs
						      height 			= "30"
						      v-model 			= "tab"
						      background-color 	= "blue-grey darken-1"
						    >
						      <v-tab
						        v-for = "(item_tab, idx_tab) of info_tabs"
						      	class = "white--text"
						        :key  = "idx_tab"
						      >
						        {{ item_tab.text }}
						      </v-tab>
						    </v-tabs>

						    <v-tabs-items v-model = "tab">
							    <v-tab-item
							        v-for = "(item_tab_i, idx_tab_i) of info_tabs"
							        :key  = "idx_tab_i"
							       
							    >
							    	<!-- 200px -->

							        <!-- :value="`tab-${idx_tab_i}`" -->
							    	<events
							    		v-show  		  		= "idx_tab_i === 0"
										:ref_to_component 		= "info_table.ref_component"
										:host_from 		  		= "info_device_id"
										:resize_to_component  	= "heigth_session_2 / 2"
									></events>
									<logs
										v-show 		= "idx_tab_i === 0"
										:info_logs  = "info.default"
										:max_height = "heigth_session_2 / 2"
									></logs>

										<!-- auto-grow -->
									<v-textarea
										filled
										no-resize
										rows  	= "15"
										v-show 	= "show_json && item_tab_i.key == 'json' "
										v-model = "info_json"
									></v-textarea>
									<v-row
										v-show = "idx_tab_i > 0"
										:max-height = "heigth_session_2"	
										:style = "`
											overflow-x 	: hidden; 
											height 		: 100%; 
											overflow-y 	: auto; 
											max-height 	: ${heigth_session_2 };
										`" 									
									>
										<template 
											v-for = "(item_field, index_field) of info_fields[item_tab_i.key]"
										>
											
											<v-col
												:xl 	= "item_field.cols.xl ? item_field.cols.xl : 4"
												:lg 	= "item_field.cols.lg ? item_field.cols.lg : 4"
												:md 	= "item_field.cols.md ? item_field.cols.md : 4"
												:xs     = "item_field.cols.xs ? item_field.cols.xs : 4"
												:cols   = "item_field.cols.cols ? item_field.cols.cols : 4"
												:offset = "item_field.cols.offset"
												:key    = "index_field"
												class   = "caption"
											>
												<!-- {{item_field}}- {{index_field}} -->
												<v-text-field
													dense
													outlined
													hide-details
													v-model   = "info[item_tab_i.key][item_field.key]"
													type 	  = "text"
													:label 	  = "$ml.get(item_field.text)  ? $ml.get(item_field.text) : item_field.text"
													class  	  = "pa-0"
													v-if 	  = "item_field.type == 'text'"
													:disabled = "!item_field.enable"			
															
												>				
													<template slot = "prepend-inner">						
														<v-icon 
															small 
															v-text = "item_field.icon" 
														></v-icon>
													</template>	
												</v-text-field>
												<v-text-field
													dense
													outlined
													hide-details
													v-model   = "info[item_tab_i.key][item_field.key]"
													type      = "password"
													:label 	  = "$ml.get(item_field.text) ? $ml.get(item_field.text) : item_field.text"
													class  	  = "pa-0"
													v-if 	  = "item_field.type == 'password'"
													:disabled = "item_field.enable"			
															
												>				
													<template slot = "prepend-inner">						
														<v-icon 
															small 
															v-text = "item_field.icon" 
														></v-icon>
													</template>	
												</v-text-field>
												<v-text-field
													dense
													outlined
													hide-details
													v-model.number  = "info[item_tab_i.key][item_field.key]"
													type 			= "number"
													:label 			= "$ml.get(item_field.text) ? $ml.get(item_field.text) : item_field.text"
													:disabled 		= "!item_field.enable"
													v-else-if 		= "item_field.type == 'number'"
												></v-text-field>
												<!-- item_field.key_link ? info[item_field.key_link][item_field.key] : info[item_tab_i.key][item_field.key]  -->
												<!--  /
												render_val_model(item_field.key_link ,item_tab_i.key, item_field.key,) -->
												<v-select
													dense
													outlined
													hide-details
													v-model 	= "info[item_tab_i.key][item_field.key]"
													:label 		= "$ml.get(item_field.text) ? $ml.get(item_field.text) : item_field.text"
													:items 		= "render_list(item_field.list)"
													v-else-if 	= "item_field.type == 'select'"
													@input 		= " sel => actions('set_select', sel, item_field.key)"
												></v-select>
												<v-card outlined 
													class 	  = "pa-0 caption" 
													height 	  = "40"
													v-else-if = "item_field.type == 'switch'"
												>
													<v-switch						
														dense						
														false-value
														hide-details
														v-model = "info[item_tab_i.key][item_field.key]"			
														:label 	= "$ml.get(item_field.text) ? $ml.get(item_field.text) : item_field.text"
														v-if 	= "item_field.type == 'switch'"					
													></v-switch>
														<!-- class="pt-0" -->
												</v-card>
												<template v-else-if = "item_field.type == 'btn'">
													
													<v-btn
														v-text = "$ml.get(item_field.text) ? $ml.get(item_field.text) : item_field.text"	
														color  = "primary"
													>
														<!-- @click="actions_fields(action_info.button)" -->
														<!-- <v-icon
															v-if="item_field.icon"						
															:color="item_field.icon_color"
															v-text="item_field.icon"
														></v-icon> -->
													</v-btn>				
												</template>
											</v-col>
										</template>
									</v-row>
								</v-tab-item>
			    			</v-tabs-items>
	    				</v-card-text>
	    				<!-- <v-divider></v-divider>	 -->
							<!-- <v-spacer></v-spacer> -->
							<!-- <v-card-actions></v-card-actions> -->
					</v-card>
				</v-col>
						<!-- Table events -->
				<!-- <v-col
					cols   = "6"
					v-show = "show_table"
				>
					
				</v-col> -->
			</v-row>
			
		</v-card-text>		
		
		
	</v-card>	
</template>
<script>
	
	import axios 					from 'axios'
	import Eventbus 				from '@/event-bus'
	import default_setting_analytic from '@/components/analytics/setting_fields.json'	
	import default_settings			from '@/components/analytics/default_setting_analytics.json'
	import alarm_roi 		 		from '@/components/alarms/alarm_roi.vue'
	import EventBus 				from '@/event-bus'
	import events 					from '@/components/events/events.vue'
	import logs 					from '@/components/analytics/analytics_logs.vue'
	export default{
		name: 'settting_analytic',
		components:{
			alarm_roi,			
			events,
			logs
		}, // components
		props: [
			'is_open_analytic',
			'info_to_analytic',

			
		], // props
		data: (vm) => ({
			info 		: {
				default: {
					vid_path : '',
				},			
				lpr : {
					vid_path : '',
				},
			},
			info_fields : default_setting_analytic,
			title 		: '',
			title1 		: '',
			dialog 	 	: false,
			tab 		: null,
			info_tabs 	: [
				{
					key  : 'events',
					text : 'events',
				},
				{
					key  : 'default',
					text : 'info',
				}
			],
			info_component 	: {},
			list_channels 	: [],
			ID_notification : 'settting_analytic',
			loading  		: false,
			info_config 	: null,
			show_table 		: false,
			info_table 	    : {
				ref_component : 'lpr',
			},			
			channel_stream  : 'hls', // motion 
			info_device_id  : '',
			action_roi : {
				action : '',
				item   : {}
			},
			shape_active : false,
			show_json  	 : false,
			info_json    : "",
			bus 		 : {},	
			tooltip 	 : {
				update : false,
			}, 
			// mls : [ 'type', 'turn', 'lane']
			heigth_session_2 : 500,

		}), // data
		watch: {
			is_open_analytic: function(val){
				if (val){
					this.dialog = true;
					// console.log(this.info_to_analytic)
					this.info = this.info_to_analytic;
				}
			}, // device

			dialog: function(val){
				if (!val) {
					this.$emit('close_analytic', false);
				}
			},

		}, // watch

		created(){
			let temp = this.$Helper.get_local('setting_analytic');
			if (temp) {

				this.$nextTick(()=>{
					// console.log(" ********************* ", this.$vuetify)
					this.heigth_session_2 = this.$vuetify.breakpoint.height;
					// temp = {"analytic":"lpr","info":{"id":8402,"name":"test4","rtsp":"rtsp://cloud.alicesecurity.co:8554/lpr1-1","xaddr":null,"user":"info@odt.com","password":"odt123456","constellation":null,"deviceId":"da42c457-e659-47a4-8759-cb7ae083f0dc","is_record":false,"limit":null,"rtsp2":"rtsp://cloud.alicesecurity.co:8554/lpr1-2","createdAt":"2021-07-23T22:19:42.190Z","updatedAt":"2021-07-23T22:19:42.190Z","container":[{"id":92,"idContainer":"298118c2a2b35bddeb5a04de7c126b3e289c8d25df20de27f15b7f51851e3ed6","path_config":"/var/lib/docker/volumes/alice-guardian/_data/config/motion/devices/test4/config.json","status":"running","type":"motion","createdAt":"2021-07-23T22:19:49.698Z","updatedAt":"2021-07-23T22:19:49.698Z","deviceId":"da42c457-e659-47a4-8759-cb7ae083f0dc"},{"id":90,"device_uuid":"da42c457-e659-47a4-8759-cb7ae083f0dc","web_uuid":"0a9c7f4d-18a6-41e4-adf9-46d5bc2f1d7f","expire":"2021-07-23T22:37:21.328Z","type":"lpr","product_name":"lpr:alice-lpr-gpu-18-costarica","version":"1.0","status":true,"updatedAt":"2021-07-23T22:37:21.491Z","createdAt":"2021-07-23T22:37:21.491Z","containerId":null},{"id":90,"device_uuid":"da42c457-e659-47a4-8759-cb7ae083f0dc","web_uuid":"0a9c7f4d-18a6-41e4-adf9-46d5bc2f1d7f","expire":"2021-07-23T22:37:21.328Z","type":"lpr","product_name":"lpr:alice-lpr-gpu-18-costarica","version":"1.0","status":true,"updatedAt":"2021-07-23T22:37:21.491Z","createdAt":"2021-07-23T22:37:21.491Z","containerId":null}]}}
					this.render_info(temp);
				})
			}
		}, // created

		computed : {
			
			currentUser() {		        
		        return this.$store.state.auth.user;      
		    }, // currentUser

		}, // computed

		methods : {
			actions(act, item, opt){
				// console.log("ACTIONS : ", act);
				if (act == 'confirm_delete') {
					EventBus.$emit('notifications_modal', {
						type : 'confirm_delete',
						ID 	: this.ID_notification
					})
				}
				if (act == 'confirm_update') {
					if (this.shape_active) {

						this.action_roi = { action : 'update'};
					}else{
						this.update();
					}
				}
				if (act == 'show_json') {
					if (this.currentUser && this.currentUser.user && this.currentUser.user.roleId == 1) {
						let idx_json = this.info_tabs.findIndex( x => (x && x.key == 'json'));
						if (idx_json < 0) {

							this.info_tabs.push({
								key : 'json',
								text : 'json'
							});
						}
						const info_ren = item;
						this.info_json = JSON.stringify(info_ren, undefined, 4);
						this.show_json = true;
					}else{
						// console.log("")
					}	
				}
				if (act == 'set_select') {
					// console.log("show select ", item, opt);
					if (this.currentUser && this.currentUser.user && this.currentUser.user.roleId == 1) {
						let info_up = null;
						if (this.title == 'lpr') {
							if (opt == 'vid_path') {

								this.info.lpr.vid_path  = item;
								info_up 				= this.info.lpr;
							}

						}	
						if (this.title == 'motion') {
							if (opt == 'vid_path') {
								
								this.info[this.title].video_source  = item;
								info_up 							= this.info[this.title];
							}

						}
						if (info_up) {
							this.info_json = JSON.stringify(info_up, undefined, 4);
						}
					}


				}
			}, // actions 

			receive_component(item1){
				if (item1) {
					// console.log("Revice points : ", item1, this.info)
					const { act, item, option } = item1;
					if (act == 'render_selecteds') {

						if (item && item.points && item.points.length > 0 && this.info && this.info.lpr && this.info.lpr['alter-config']){
							console.log("REnder formated lpr", item);
							let temp_rois = [];
							let temp_points =  item.points[0];
							if (temp_points.left &&
								temp_points.top  &&
								temp_points.width &&
								temp_points.height) {

								temp_rois.push((temp_points.left) * 1 );
								temp_rois.push((temp_points.top) * 1 );
								temp_rois.push((temp_points.width) * 1 );
								temp_rois.push((temp_points.height) * 1 );

							this.info.lpr['alter-config'].roi_limits = temp_rois;
							}else{
								console.log("A property is  missing left/top/width/height : ", temp_points)
							}
							if (item.points[1] && item.points[1].scale){
								this.info.lpr['alter-config'].scales[0] = item.points[1].scale;
								const temp_scale = item.points[1];
								if (temp_scale && temp_scale.scale) {
									this.info.lpr['alter-config'].roi_scale =  { ...temp_scale };
								}
								/*this.info.lpr['alter-config'].scales[1] = 0.15;
								this.info.lpr['alter-config'].scales[2] = 0.14;*/
							}							
							if (this.currentUser && this.currentUser.user && this.currentUser.user.roleId == 1 ) {
								if (this.info_tabs[this.tab].key != 'json' ) {
									try {

									this.info_json = JSON.stringify(this.info.lpr, undefined, 4);
									}catch(er){
										console.log("Error parse json lpr RS", er)
									}
								}
							}
						}else{
							console.log("No exist some this propiertys, scale, roi, lpr,alter-config")
						}
						this.update();
					} // render_selecteds
					if (act == 'update') {

					}

				}
			},// receive component

			/*recive_info(val, from){
				if (val.action == 'save') {
					console.log('step 4, recive');
					// this.inf.info = val.value;
					// this.save();
				}
			}, // recive_info*/
			render_val_model(key, val, val1){
				if (key) {
					return this.info[key][val];
				}
				return this.info[val][val1]
			}, // render_val_model

			render_info(item){
				if (item) {
					let vm 							= this;
					let analytic_temp 				= item.analytic ? item.analytic : ''; 
					this.title  					= analytic_temp;
					this.info_table.ref_component 	= analytic_temp;
					this.info[analytic_temp] 		= {}; 
					let channel_select  			= '';

					if (item.analytic == 'lpr') {
						// this.info.lpr = {};
						this.info_tabs.push({
							key  : 'lpr',
							text : 'Advanced'
						});
						this.info.lpr 		= default_settings && default_settings[item.analytic] ? default_settings[item.analytic] : default_settings;
						this.show_table 	= true;
						this.channel_stream = 'lpr';
						// console.log("JSON SHOW : ", this.info.lpr)
						/*if (this.info && this.info.lpr && this.info.lpr.params && this.info.lpr.params.length > 0 ) {

							this.actions('show_json', this.info.lpr.params[0]);
						}*/
						
					}
					// console.log("ITEM RENDER : " , item)			
					if (item.info) {				
						this.title1 = item.info.name;
						this.list_channels.push(this.$Format.format_local_hls({...item.info})); // item.info.rtsp
						this.list_channels.push(this.$Format.format_local_hls({...item.info}, "local", 2)); // item.info.rtsp
						this.list_channels.push(item.info.rtsp);
						if (item.info.rtsp2) {								
							this.list_channels.push(item.info.rtsp2);								
						}

						if (['lpr','motion'].includes(this.title)) {
							if (item.info.rtsp) {
								if (item.analytic == 'lpr') {
									this.info.lpr.vid_path = item.info.rtsp;
								}else{
									channel_select = item.info.rtsp;
								}
							}
							if (item.info.rtsp2) {
								
								this.list_channels.push(item.info.rtsp2);
								
							}
						}
						if (item.info.deviceId) {
							this.info_device_id = item.info.deviceId;
						}
						if (item.info.container && item.info.container.length > 0) {
							const find = item.info.container.some((cont, idx_cont) => {
								if (cont.type == item.analytic) {
									cont.vid_path 	= '';
									vm.info.default = cont;
									if (channel_select) {
										vm.info.default.vid_path = channel_select;
									}
									// if (cont.type == 'lpr') {
									console.log("CONTAINER SET ", cont.type,cont )
									const timer = setTimeout(()=>{
										EventBus.$emit('select_log_container', cont);
										clearTimeout(timer);
									}, 3000)
									vm.get_lpr(cont.idContainer);
									// }
									return true;
								}

							})
							if (!find && item.container) {
								console.log("container storage", item);
								// cont.vid_path 	= '';
								vm.info.default = item.container;
								vm.get_lpr(item.container.idContainer)
							}
						}
					}
					this.info_component = item.info;
				}
			}, // render info

			get_lpr(ID){
				// let ID = this.info_component && this.info_component.idContainer ? this.info_component.idContainer : null;
				if (ID) {

					const api = this.$URL + '/api/v1/lpr/show';
					this.$axios.post(api, { idContainer : ID }).then(res => {
						console.log("Res get lpr : ", res);
						if (res && res.data) {
							this.format_info(res.data);
						}
					}).catch( er => {{
						console.log( "Error get lpr : ", er);
						this.$EventBus.$emit('notifications_modal', {
								type : 'error',
								message : 'Get info analitic'
							})
						let err = er && er.message ? er.message : er;
						this.$EventBus.$emit('action_analytic', {
							action : 'Get info container : ' + err,
							color  : 'error'
						});
					}})
				}else{
					console.log("No found ID to get info ");
					this.$EventBus.$emit('action_analytic', {
						action : 'Get info container :  ' + 'No found ID to get info ',
						color  : 'error'
					});
				}
			}, // get lpr

			format_info(item){
				let vm = this;
				console.log("check json : ", item)
				if (item) {
					this.info_config = item;

					if (item.config && item.config.length > 0){
						item.config.forEach((conf, idx_conf) =>{
							if (conf) {
								if (conf.params && conf.params.length > 0) {
									if (conf.config && conf.config.includes('lpr')) {
										vm.info.lpr = conf.params[0];
										vm.info.default.vid_path = conf.params[0].vid_path;
										vm.list_channels.push(conf.params[0].vid_path);
										if (conf.params[0]['alter-config']) {
											let temp_alter = { 
												deviceId : vm.info.default.deviceId,
												points : [],
												info_scale : null,
											};
											if (conf.params[0]['alter-config'].roi_limits && conf.params[0]['alter-config'].roi_limits.length > 0 ){
												
												temp_alter.points.push(conf.params[0]['alter-config'].roi_limits)

											}
											if (conf.params[0]['alter-config'].scales && conf.params[0]['alter-config'].scales.length > 0) {
												temp_alter.info_scale = conf.params[0]['alter-config'].scales[0];

											}
											if (conf.params[0]['alter-config'].scales && conf.params[0]['alter-config'].roi_scale) {
												temp_alter.roi_scale = {...conf.params[0]['alter-config'].roi_scale};
											}
											// if (conf.params[0]['alter-config'].info) {}
											

											// set to roi / scale
											// vm.info_component = temp_alter;
											vm.action_roi = {
												action : 'update_rois',
												item   : temp_alter
											};
											vm.shape_active = true;


											vm.actions('show_json', conf.params[0]);

											console.log("INFO  ROIS ************************** ", temp_alter,conf.params[0]['alter-config'].roi_limits , conf.params[0]['alter-config']);
										}
									}else if (conf.config && conf.config.includes('')) {
										let name_config   = conf.config && conf.config.split('_') ? 
															conf.config.split('_') : 
															vm.title;
										let name_config_1 = conf.config && name_config && name_config.length > 0 ? name_config[0] : name_config
										
										console.log("NAME CONFIG : ¨¨¨****************** ", conf.config, name_config_1)
										// set info to show and fields
										vm.info[name_config_1] 		  = conf.params[0];
										vm.info_fields[name_config_1] = [];

										

										// add tab
										vm.info_tabs.push({
											key : name_config_1,
											text : name_config_1,
										});

										/*
											{
												"key": "quadrants",
												"text": "quadrants",
												"type":	"number",		
												"enable":  false,
												"visible"	: 	true,
												"cols": {
													"xl": "4",
													"lg": "4",
													"md": "4",
													"xs": "12",
													"cols": "12"
												}
											}
										*/
										// render field not exists
										let fields = []; // fields temp
										// console.log("PARAMS ****"," key : " + iter ," Value: " + conf.params[0]);
										fields = vm.format_fields(conf.params[0])

										// set info of fields
										if (fields) {
											vm.info_fields[name_config_1] = fields;
										}else{
											console.log("Error format fields : ", name_config_1);
										}

										
									}
								}else{
									console.log("No found params : ", conf.config);
									this.$EventBus.$emit('action_analytic', {
										action : 'No found params config',
										color  : 'warning'
									});
								}

							}else{
								console.log("No found config : ", conf.config);
								this.$EventBus.$emit('action_analytic', {
										action : 'No found config',
										color  : 'warning'
									});

							}
						})
					} // config
					else{ // other type json
						if (item.config &&  typeof item.config == 'object') {
							let name_config_1 	= this.title;
							let fields 			= [];
							vm.info_tabs.push({
								key : name_config_1,
								text : 'Advanced',
							});
							vm.info[name_config_1] 	= item.config;
							if (vm.title == 'motion') {
								vm.info.default.vid_path = item.config.video_source;
							}

							fields 					= vm.format_fields(item.config);
							if (fields) {
								vm.info_fields[name_config_1] =  fields;
							}else{
								console.log("Error format fields : ", name_config_1);
							}
							vm.actions('show_json', item.config);
						}
					}
					if (item.container) {

					}
					
				} // item

			}, // format info

			render_list(key){
				return this[key];
			}, // render list

			format_fields(items){
				let fields = [];
				if (items) {
					for (let iter in items){
												
						let type_field = "text";/*typeof conf.params[0][iter];
						if (type_field == 'string') {
							type_field = "text";
						}else if(type_field == 'object'){
							if (Array.isArray(conf.params[0][iter].isArray)) {
								type_field = 'select'
							}else{
								type_field = "text"
							}
						} */

						fields.push({
							"key": iter,
							"text": iter,
							"type": type_field,		
							"enable":  false,
							"visible"	: 	true,
							"cols": {
								"xl": "4",
								"lg": "4",
								"md": "4",
								"xs": "12",
								"cols": "12"
							}
						})

					} // for

					return fields;
				}
				return null;

			}, // format fields
			
			

			update(item){
				// if (item) {				
				console.log(this.info_config ? true : false)
				let info_up = this.info_config;
				let vm 		= this;
				console.log("check JSON  : ", this.info_tabs[this.tab].key);
				// if (info_up) {


				let timer 	= setTimeout(()=>{					
					vm.action_roi 	= { action : '' };
					if (!this.$store.getters["auth/permission"]( this.$route.name || "setting_analytic", "can_edit", "device")) {
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("setting_analytic"),
						})						
						return false;
					}

					if (info_up && info_up.config && info_up.config.length > 0) {
						console.log( "BEFORE RENDER UPDATE : ", info_up.config )
						info_up.config.forEach( (conf, idx_conf) => {			
							let name_config   =  conf.config ? conf.config.split('_') : vm.title;
							let name_config_1 = conf.config && name_config && name_config.length > 0 ? 					
												name_config[0] : name_config;
								console.log("NAME SAVE : ", name_config , name_config_1, vm.info[name_config_1]);
							if (vm.info[name_config_1]) {
								conf.params[0] = vm.info[name_config_1];

								// set other values
								if (name_config_1 == 'lpr') {

									if (conf.params[0].id !== vm.info.default.id) {
										conf.params[0].id = "1"; //vm.info.default.id;
									}
									// if (conf.params[0].vid_path && !conf.params[0].vid_path) {
									conf.params[0].vid_path = vm.info.default.vid_path;
									console.log( "vid path : " ,conf.params[0].vid_path, vm.info.default.vid_path)
									// }
									// if (!conf.params[0].entry_type) {
									// 	conf.params[0].entry_type  = 1;
									// }
									console.log("check JSON :", this.info_tabs[this.tab].key);
									if (this.info_tabs[this.tab].key == 'json' ) {
										conf.params[0] = JSON.parse(this.info_json);
										console.log("set params json : ", conf.params[0]);
									}
								}
								if (name_config_1 == 'motion') {

									if (conf.params[0].video_source){
										conf.params[0].video_source = conf.params[0].vid_path = vm.info.default.vid_path;
									}
								}

							}
						})
					}else{
						let analytic = vm.title;
						if (info_up && info_up.config) {
							info_up.config = vm.info[analytic]; 
							if (info_up.config.video_source) {
								info_up.config.video_source = vm.info.default.vid_path;
							}
							console.log("check JSON 1 ~ : ", this.info_tabs[this.tab].key);

							if (this.info_tabs[this.tab].key == 'json' ) {
								info_up.config = JSON.parse(this.info_json);
								console.log("set params json : ", info_up/*conf.params[0]*/);
							}
						}
					}
					this.loading = true;
					
					console.log("UPDATE : *********** ", info_up);

					// item.idContainer
					let ID = vm.info.default && vm.info.default.idContainer ? vm.info.default.idContainer : null;
					if (info_up && ID) {
						this.$EventBus.$emit('action_analytic', {
							action : 'Updating ...',
							color  : 'success'
						});
						const api = this.$URL + '/api/v1/lpr/update/' + ID;
							this.$axios.put(api, info_up).then(res => {
								console.log("Res update lpt : ", res);
								this.$EventBus.$emit('notifications_modal', {
									type : 'updated'
								})
								this.loading = false;
								EventBus.$emit('action_analytic', {
									action : 'Updated ...',
									color  : 'success'
								});
								try{

									EventBus.$emit('action_analytic_req', {
										action : 'restart',
										color  : 'primary'
									});

								}catch(e){
									console.log("Error sending bus req", e);
								}
								this.$EventBus.$emit('notifications_modal', {
									type  	: 'primary',
									message : this.$ml.get('restart') + ' : ' + this.$ml.get('analytic') 
								})
							}).catch( er => {{
								console.log( "Error update lpr : ", er);
								this.$EventBus.$emit('notifications_modal', {
									type : 'error',
									message : 'update configuration'
								})
								let err = er && er.message ? er.message : er;
								this.$EventBus.$emit('action_analytic', {
									action : 'Error update : ' +  err,
									color  : 'error'
								});
								this.loading = false;					
							}})

					}else{
						this.$EventBus.$emit('notifications_modal',{
							type 	: 'warning',
							message : 'Info to update not valid'
						});
						this.$EventBus.$emit('action_analytic', {
							action : 'Info to update not valid',
							color  : 'warning'
						});
						console.log("No valid to update : ", ID , info_up)
					}
					clearTimeout(timer);
				}, 50)
			/*}else{
				console.log("no info to update : ", info_up)
			}*/
			}, // update

			del(item){

				if (!this.$store.getters["auth/permission"]( this.$route.name || "setting_analytic", "can_delete", "device")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("setting_analytic"),
					})					
					return false;
				}

				this.$EventBus.$emit('action_analytic', {
					action : 'Delete container ...',
					color  : 'success'
				});
				if (item && item.id) {
					const api = this.$URL + '/api/v1/container/' + item.id;
					this.$axios.delete(api).then( res => {
						console.log( "res delete ", this.ID_notification);
						this.$EventBus.$emit('action_analytic', {
							action : 'Deleted container',
							color  : 'success'
						});
						this.$router.back();
					}).catch( er => {
						console.log( "Error delete ", this.ID_notification);
						let err = er && er.message ? er.message : er;
						this.$EventBus.$emit('action_analytic', {
							action : 'Error Delete container : ' + err,
							color  : 'error'
						});
					})
				}else{
					console.log("No found ID to Delete");
					this.$EventBus.$emit('action_analytic', {
						action : 'Error Delete container : Not Found id to delete',
						color  : 'warning'
					});
				}

			}, // reset

		}, // methods

		mounted(){
			console.log("TYPE OF ********************+ ",typeof [], typeof "sdas", typeof {}, typeof 23)	
			let temp_bus = 'notifications_modal' + this.ID_notification;		
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) => {
				if (action) {
					this.del(this.info.default);
				}
			})
			let temp_bus1 = 'loading_setting_analytic';
			EventBus.$on(temp_bus1, this.bus[temp_bus1] = (action) => {				
				this.loading = action;				
			});
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, 'settings_analytics');
			this.loading = false;
		}, // before destroy

	}; // export defaul
</script>
